import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/originui/select';
import { useId } from 'react';
import { GroupType } from '@/types/api/group';
import { groupTypeLabels } from '@/utils/group/group-label-maps';
import { useFormContext } from '@/contexts/form-context';

interface GroupTypeFormSelectProps {
  label: string;
  name: string;
}

export default function GroupTypeFormSelect({ name, label }: GroupTypeFormSelectProps) {
  const form = useFormContext();

  const id = useId();
  return (
    <form.Field
      name={name}
      children={(field) => (
        <div className="group relative">
          <label
            htmlFor={id}
            className="bg-background text-foreground absolute start-1 top-0 z-10 block -translate-y-1/2 px-2 text-xs font-medium group-has-disabled:opacity-50"
          >
            {label}
          </label>
          <Select
            defaultValue={field.state.value as GroupType}
            onValueChange={field.handleChange}
            value={field.state.value as GroupType}
          >
            <SelectTrigger id={id}>
              <SelectValue placeholder="Select framework" />
            </SelectTrigger>
            <SelectContent>
              {Object.values(GroupType).map((type) => (
                <SelectItem value={type}>{groupTypeLabels[type]}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    />
  );
}
